export const AUTHENTICATE = 'AUTHENTICATE';
export const DEAUTHENTICATE = 'DEAUTHENTICATE';
export const NOTIFY = 'NOTIFY';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
// workspaces list mutations
export const ADD_WORKSPACE = 'ADD_WORKSPACE';
export const DELETE_WORKSPACE = 'DELETE_WORKSPACE';
export const SET_WORKSPACES = 'SET_WORKSPACES';
// workspace mutations
export const SET_CURRENT_WORKSPACE = 'SET_CURRENT_WORKSPACE';
export const UPDATE_WORKSPACE = 'UPDATE_WORKSPACE';
export const SET_WORKSPACE_PREVIEW = 'SET_WORKSPACE_PREVIEW';
// base data mutations
export const SET_LAYERS = 'SET_LAYERS';
export const SET_LOADING = 'SET_LOADING';
export const SET_UNITS = 'SET_UNITS';
export const SET_TIMESLICES = 'SET_TIMESLICES';
export const SET_REGIONS = 'SET_REGIONS';
export const SET_MODELS = 'SET_MODELS';
export const SET_SCENARIOS = 'SET_SCENARIOS';
export const SET_RUNS = 'SET_RUNS';
export const SET_METADATA_TYPES = 'SET_METADATA_TYPES';
export const SET_CHARACTERISTICS = 'SET_CHARACTERISTICS';
// panel list mutations
export const ADD_PANEL = 'ADD_PANEL';
export const REMOVE_PANEL = 'REMOVE_PANEL';
export const REORDER_PANELS = 'REORDER_PANELS';
export const CLONE_PANEL = 'CLONE_PANEL';
// panel mutations
export const TOGGLE_PANEL_SIZE = 'TOGGLE_PANEL_SIZE';
export const SET_PANEL_SELECTION = 'SET_PANEL_SELECTION';
export const SET_PANEL_RAW_DATA = 'SET_PANEL_RAW_DATA';
export const SET_PANEL_OPTS = 'SET_PANEL_OPTS';
// interaction mutations
export const SET_ACTIVE_DATASETS = 'SET_ACTIVE_DATASETS';
// screens mutations
export const SET_WORKSPACES_FILTER = 'SET_WORKSPACES_FILTER';
export const TOGGLE_WORKSPACES_FILTER = 'TOGGLE_WORKSPACES_FILTER';
export const PUSH_WORKSPACE_TO_RECENT = 'PUSH_WORKSPACE_TO_RECENT';
export const SET_SKIP_TOUR = 'SET_SKIP_TOUR';
export const TOGGLE_DARK_THEME = 'TOGGLE_DARK_THEME';
// profile
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_CONFIG = 'SET_USER_CONFIG';
// downloads
export const SET_FILES = 'SET_FILES';
